<div (click)="changeCheckState()" class="card custom-card" [ngClass]="{'card-selected': isEnabled}">
    <div class="d-flex justify-content-between" style="margin-bottom: 10px; height: 20px;">
        <i [class]="'fas ' + iconClass"></i>
        <span *ngIf="isEnabled" class="text-success-dark" style="font-size: 0.8em;">Selecionado</span>
    </div>
    <p><strong>{{title}}</strong></p>
    <p style="font-size: 14px">{{description}}</p>
</div>